/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class ChatAPI extends ApiClient {
  constructor() {
    super('loco/chat', { accountScoped: true });
  }

  channels() {
    return axios.get(`${this.url}/channels`);
  }

  channel(id) {
    return axios.get(`${this.url}/channels/${id}`);
  }

  createChannel(payload) {
    return axios.post(`${this.url}/channels`, payload);
  }

  updateChannel(id, payload) {
    return axios.patch(`${this.url}/channels/${id}`, payload);
  }

  archiveChannel(id) {
    return axios.delete(`${this.url}/channels/${id}`);
  }

  direct(userIds) {
    return axios.post(`${this.url}/channels/direct`, { user_ids: userIds });
  }

  join(id) {
    return axios.post(`${this.url}/channels/${id}/join`);
  }

  leave(id) {
    return axios.post(`${this.url}/channels/${id}/leave`);
  }

  read(id, messageId) {
    return axios.post(`${this.url}/channels/${id}/read`, {
      message_id: messageId,
    });
  }

  saveDraft(id, content) {
    return axios.put(`${this.url}/channels/${id}/draft`, { content });
  }

  setNotifications(id, notifications) {
    return axios.patch(`${this.url}/channels/${id}/membership`, {
      notifications,
    });
  }

  typing(id) {
    return axios.post(`${this.url}/channels/${id}/typing`);
  }

  addMembers(id, userIds) {
    return axios.post(`${this.url}/channels/${id}/members`, {
      user_ids: userIds,
    });
  }

  messages(channelId, before) {
    return axios.get(`${this.url}/channels/${channelId}/messages`, {
      params: before ? { before } : {},
    });
  }

  replies(channelId, messageId) {
    return axios.get(
      `${this.url}/channels/${channelId}/messages/${messageId}/replies`
    );
  }

  // { content, mentions, parentId, files }
  send(channelId, { content, mentions = [], parentId, files = [] }) {
    const url = `${this.url}/channels/${channelId}/messages`;
    if (!files.length) {
      return axios.post(url, { content, mentions, parent_id: parentId });
    }
    const form = new FormData();
    if (content) form.append('content', content);
    if (parentId) form.append('parent_id', parentId);
    mentions.forEach(id => form.append('mentions[]', id));
    files.forEach(file => form.append('files[]', file));
    return axios.post(url, form);
  }

  editMessage(channelId, messageId, content) {
    return axios.patch(
      `${this.url}/channels/${channelId}/messages/${messageId}`,
      { content }
    );
  }

  deleteMessage(channelId, messageId) {
    return axios.delete(
      `${this.url}/channels/${channelId}/messages/${messageId}`
    );
  }

  react(channelId, messageId, emoji) {
    return axios.post(
      `${this.url}/channels/${channelId}/messages/${messageId}/react`,
      { emoji }
    );
  }

  search(q) {
    return axios.get(`${this.url}/search`, { params: { q } });
  }
}

export default new ChatAPI();
